import request from '@/util/request';

/** 获取用户信息 */
export const getUserInfoInDirect = async () => {
  let data;
  data = await request('/ec-manage/platform/account/queryAccountInfo', {
    method: 'GET',
  });
  return data;
};


/** 获取运维用户信息（权限已迁至 equipment-maintenance，无数据即无权限） */
export const getUserInfoInOperate = async () => {
  const data = await request('/equipment-maintenance/user/userInfo', {
    method: 'GET',
  });
  if (data) {
    data.realPhone = data?.cellphone;
  }
  return data;
};
